import { jsx, jsxs } from 'react/jsx-runtime';
import { SVG } from './utils/style.svg.js';
import { getDefaultHeight } from './utils/get-default-height.js';

const LogoutIcon = ({
  color,
  ...svgProps
}) => {
  return /*#__PURE__*/jsx(SVG, {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 13.539 12.714",
    height: getDefaultHeight(svgProps, 12.714),
    ...svgProps,
    children: /*#__PURE__*/jsxs("g", {
      fill: "none",
      stroke: color ?? "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.2",
      children: [/*#__PURE__*/jsx("path", {
        d: "M4.303 6.359h8.636"
      }), /*#__PURE__*/jsx("path", {
        d: "M10.883 8.415l2.056-2.056-2.056-2.056"
      }), /*#__PURE__*/jsx("path", {
        d: "M8.827 8.825v2.467a.788.788 0 01-.748.822H1.353a.788.788 0 01-.747-.822v-9.87A.787.787 0 011.353.6h6.726a.788.788 0 01.748.822V3.89"
      })]
    })
  });
};

export { LogoutIcon };
//# sourceMappingURL=logout.js.map
